import classNames from 'classnames';
import { svgSprite } from '../../hybrid/wrappers';
import css from './Notification.module.scss';

const Notification = (props) => {
    const { icon, title, description, buttonText, buttonFunc, customCss = {} } = props;
    return (
        <div className={classNames(css.notification, customCss.notification)}>
            <div className={css.notification_left}>
                {icon ? (
                    <div className={css.notification_icon}>
                        {svgSprite(icon, { className: classNames(css.notification_icon_svg, customCss?.icon) })}
                    </div>
                ) : null}
                <div className={css.notification_content}>
                    <p className={classNames(css.notification_title)}>{title}</p>
                    {description ? (
                        <p className={classNames(css.notification_description, { [css.mt0]: !title })}>{description}</p>
                    ) : null}
                </div>
            </div>
            <div className={css.notification_right}>
                {buttonText && buttonFunc && typeof buttonFunc === 'function' ? (
                    <button onClick={buttonFunc} className={classNames('defaultButton grow', css.notification_button)}>
                        {buttonText}
                    </button>
                ) : null}
            </div>
        </div>
    );
};

export default Notification;
